import React, { useState } from "react";

const WaterIntakeSection = ({ waterData, setIsWaterIntakeOpen }) => {
  const currentDate = new Date();
  const tdate =
    currentDate.getDate() +
    " " +
    currentDate.toLocaleString("default", { month: "short" }) +
    " " +
    currentDate.getFullYear();
  const [numGlass] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
  ]);
  if (waterData) {
    return (
      <>
        <div className="sm:w-full md:w-full w-full">
          <div className="">
            <div className="tabroe">
              <div className="modetit text-lg">Water intake</div>
              <div className="modesutit text-[11px]">Today, {tdate}</div>
            </div>
          </div>
          <div className="fastiweekbox pb-[8px]">
            <div className="fasweekdes ">
              <div className="flex gap-2">
                <img
                  loading="lazy"
                  src="../images/deshboard/water.webp"
                  alt="mode"
                />
                <div className="tabroe">
                  <div className="modetit">Consumption</div>
                  <div className="modesutit">
                    {waterData?.todayTotalWaterintake != 0
                      ? "Last logged at "
                      : "Not logged yet "}
                    {waterData?.todayTotalWaterintake != 0 ? tdate : ""}
                  </div>
                </div>
              </div>
              {setIsWaterIntakeOpen ? (
                <div
                  className="plusbox cursor-pointer"
                  onClick={() => {
                    setIsWaterIntakeOpen(true);
                  }}
                >
                  <img
                    loading="lazy"
                    src="../images/deshboard/pluse.webp"
                    alt="pluse"
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
            <div>
              <hr />
            </div>
            <div className="fasweekdes">
              <div className="mode1">
                <div className="tabroe">
                  <div className="modesutit">Intake</div>
                  <div className="tabetsbol">
                    {waterData?.todayTotalWaterintake ||
                      0 + " " + waterData?.waterIntakeType ||
                      ""}
                  </div>
                </div>
                <div className="tabroe">
                  <div className="modesutit">Required</div>
                  <div className="tabetsbol">
                    {waterData?.waterRecommendation -
                      waterData?.todayTotalWaterintake ||
                      +" " + waterData?.waterIntakeType ||
                      ""}
                  </div>
                </div>
              </div>
              <div className="tabroe pb-2">
                <div className="modesutit">Recommended</div>
                <div className="tabetsbol">
                  {waterData?.waterRecommendation ||
                    0 + " " + waterData?.waterIntakeType ||
                    "Ml"}{" "}
                </div>
              </div>
            </div>
            <div className="fasweekdes">
              {numGlass.map((glassRow, index) => (
                <div key={index}>
                  <img
                    loading="lazy"
                    src={
                      "../images/deshboard/" +
                      (waterData?.todayTotalWaterintake / 250 >= glassRow
                        ? "glassfill.webp"
                        : "glass.webp")
                    }
                    alt="glass"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default React.memo(WaterIntakeSection);
